import axios from "axios";
import { GET_ALL_SUBSCRIPTION, GET_ALL_SUBSCRIPTION_FAILED, GET_ALL_SUBSCRIPTION_SUCCESS } from "../../constants/subscriptionListConstants";

export  const GetAllSubscription = () => async(dispatch) => {
            console.log("res__");
            dispatch({type: GET_ALL_SUBSCRIPTION});
        try {
            const res = await axios.get("/store/product/subscription?environment=all");
            console.log(res);
            console.log("res__");
            dispatch({type: GET_ALL_SUBSCRIPTION_SUCCESS, payload: res.data});

        } catch(error) {
            dispatch({type: GET_ALL_SUBSCRIPTION_FAILED, payload: error.message});
        }
}

